import styled from 'styled-components'

import { Tooltip } from '@/components/ui/tooltip'

export const Content = styled.form(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
}))

export const FormSection = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['24'],
}))

export const SelectorSection = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
}))

export const SelectorLabel = styled.p(({ theme }) => ({
  color: theme.colors.primary800,
  fontSize: '1.4rem',
  fontWeight: 500,
  lineHeight: '2rem',
}))

export const FieldGrid = styled.div(({ theme }) => ({
  display: 'grid',
  gap: theme.space['16'],
  gridTemplateColumns: '1fr 1fr',
}))

export const FieldGrid3 = styled.div(({ theme }) => ({
  display: 'grid',
  gap: theme.space['16'],
  gridTemplateColumns: '1fr 1fr 1fr',
}))

export const FieldGridFull = styled.div(({ theme }) => ({
  display: 'grid',
  gap: theme.space['16'],
  gridTemplateColumns: '1fr',
}))

export const Divider = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.primary200,
  height: '1px',
  width: '100%',
}))

export const SectionTitle = styled.p(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '1.4rem',
  fontWeight: 600,
  lineHeight: '2rem',
}))

export const WeekdayRow = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.space['8'],
}))

export const WeekdayButton = styled.button<{ $active: boolean }>(({ theme, $active }) => ({
  alignItems: 'center',
  background: $active ? theme.colors.primary800 : theme.colors.white,
  border: `${theme.border.size['1']} solid ${$active ? theme.colors.primary800 : theme.colors.gray400}`,
  borderRadius: '50%',
  color: $active ? theme.colors.white : theme.colors.black600,
  cursor: 'pointer',
  display: 'flex',
  flexShrink: 0,
  fontSize: '1.2rem',
  fontWeight: 500,
  height: '3.6rem',
  justifyContent: 'center',
  width: '3.6rem',
}))

export const WeekdayHint = styled.p(({ theme }) => ({
  color: theme.colors.black500,
  fontSize: '1.2rem',
  lineHeight: '1.6rem',
}))

export const MonthlySummary = styled.p(({ theme }) => ({
  color: theme.colors.black600,
  fontSize: '1.4rem',
  lineHeight: '1.8rem',
}))

export const CalendarWrapper = styled.div(() => ({
  display: 'flex',
  justifyContent: 'center',
  margin: '0 auto',
  maxWidth: '100%',
  width: '324px',
}))

export const NoteToggleRow = styled.div(() => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
}))

export const NoteToggleLabel = styled.p(({ theme }) => ({
  color: theme.colors.black700,
  fontSize: '1.4rem',
  fontWeight: 500,
  lineHeight: '2rem',
}))

export const AccessRow = styled.div(({ theme }) => ({
  '& > * + *': {
    borderTop: `${theme.border.size['1']} solid ${theme.colors.primary200}`,
  },
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
}))

export const AccessItem = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['4'],
  width: '100%',
}))

export const AccessToggleRow = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  padding: `${theme.space['20']} ${theme.space['0']}`,
}))

export const LabelGroup = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['4'],
}))

export const AccessDescription = styled.p(({ theme }) => ({
  color: theme.colors.black500,
  fontSize: '1.2rem',
  lineHeight: '1.6rem',
}))

export const InlineTooltip = styled(Tooltip)({
  width: 'auto',
})
